// 导入axios
import axios from 'axios';
import qs from 'Qs';
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dataUrl from './baseUrl';
import {
  Loading,
  Message
} from 'element-ui'
import store from '@/store';
Vue.use(ElementUI);

// 进行一些全局配置
// 请求响应超时时间
axios.defaults.timeout = 10000;
// axios.defaults.transformRequest = [function (data) {
//   let ret = ''
//   for (let it in data) {
//     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
//   }
//   return ret
// }]


const specialArr = [
  dataUrl.baseurl + '/sjpt/tourism/visitorUser/updateVisitorUser',
  dataUrl.baseurl + '/sjpt/reservation/hotel/booking',
  dataUrl.baseurl + '/sjpt/reservation/restaurant/booking',
  dataUrl.baseurl + '/sjpt/reservation/specialty/submit',
  dataUrl.baseurl + '/sjpt/reservation/ticket/booking',
  dataUrl.baseurl + '/sjpt/reservation/explanation/booking',
  dataUrl.baseurl + '/sjpt/tourism/visitorUser/updateVisitorUser',
  dataUrl.baseurl + '/sjpt/reservation/order/comment',

];
axios.interceptors.request.use(config => { //请求拦截
  config.headers['common']['Language'] = 'cn' //请求语言
  if (localStorage.getItem('token')) {
    config.headers['common']['access-token'] = localStorage.getItem('token') //请求语言
  }
  // console.log(config)
  if (specialArr.includes(config.url)) {
    config.headers['Content-Type'] = 'application/json'
  } else {
    if (config.data && config.data instanceof FormData && config.data.get("file")) {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      if (config.method === 'post') config.data = qs.stringify(config.data)
    }

  }
  startLoading();
  return config
}, error => {
  return Promise.reject(error)
})

// loading
let loading;
//内存中正在请求的数量
let loadingNum = 0;

function startLoading() {
  if (loadingNum == 0) {
    loading = Loading.service({
      lock: true,
      // text: '拼命加载中...',
      // spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.8)',
      target: document.querySelector('#app') // 设置加载动画区域
    })
  }
  //请求数量加1
  loadingNum++;
}

function endLoading() {
  //请求数量减1
  loadingNum--
  if (loadingNum <= 0) {
    loading.close()
  }
}

//接收响应拦截器
axios.interceptors.response.use(response => {
  endLoading();
  // console.log(response)
  if (response.data.code != 200) { //错误提示
    if (response.data.status == 1000 || !response.data.message) { // 天气接口   message没有值

    }
    else {
      Message({
        showClose: true,
        message: response.data.message,
        type: "error",
        center: true,
        duration: 1000
      })
    }

    if (response.data.code == 201) {
      localStorage.removeItem('token');
      store.commit("setUserInfo", '');
      window.location.href = "/#/login";
    }
  }
  return response
}, err => {
  endLoading();
  console.log(err.response)
  //   if (err && err.response) {
  //     switch (err.response.status) {
  //       case 403: err.message = '拒绝访问(403)'; break;
  //       case 201: err.message = '登录失效，请重新登录';break;
  //       case 404: err.message = '请求出错(404)'; break;
  //       case 408: err.message = '请求超时(408)'; break;
  //       case 500: err.message = '服务器错误(500)'; break;
  //       case 501: err.message = '服务未实现(501)'; break;
  //       case 502: err.message = '网络错误(502)'; break;
  //       case 503: err.message = '服务不可用(503)'; break;
  //       case 504: err.message = '网络超时(504)'; break;
  //       case 505: err.message = 'HTTP版本不受支持(505)'; break;
  //       default: err.message = '连接出错!';
  //     }
  //   } else {
  //     // err.message = '连接服务器失败!'
  //   }
  // console.log(err)
  if (err && err.response.status == 500 && err.response.config.url.indexOf('/address/default') == -1) {
    if (err.response.data.message === 'ticket.id.number.cannot.be.empty') {
      Message({
        showClose: true,
        message: '身份证号码不能为空',
        type: "error",
        center: true,
        duration: 2000
      })
    } else if (err.response.data.message === 'age.does.not.meet.the.conditions.of.this.ticket') {
      Message({
        showClose: true,
        message: '您的购买年龄不符合购买要求',
        type: "error",
        center: true,
        duration: 2000
      })
    } else {
      Message({
        showClose: true,
        message: err.response.data.message || err.response.data.msg,
        type: "error",
        center: true,
        duration: 2000
      })
    }
  }

  // Message.error(err);
  return Promise.reject(err);
});



// 封装自己的get/post方法
export default {
  get: function (path = '', data = {}) {
    return new Promise(function (resolve, reject) {
      axios.get(path, {
        params: data
      }).then(function (response) {
        // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
        resolve(response.data);
      }).catch(function (error) {
        // console.log(error)
        reject(error);
      });
    });
  },
  post: function (path = '', data = {}) {
    return new Promise(function (resolve, reject) {
      axios.post(path, data).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        // console.log(error)
        reject(error);
      });
    });
  },
  delete: function (path = '', data = {}) {
    return new Promise(function (resolve, reject) {
      axios.delete(path, {
        params: data
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        // console.log(error)
        reject(error);
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/assets/api/request.js